module.exports = __webpack_public_path__ + "img/type2-bg2.f4598aa1.png";